import { defineSlotRecipe } from '@chakra-ui/react';
import { inputFieldBase, inputFieldSizes, inputFieldVariants } from './Input';
import { Colors, Space, LineHeights } from '../../types';

// The field reuses the shared input styles.
// Stock nativeSelect sizes set `ps`, which outranks base's paddingInlineStart, so ours is restated as `ps`.
const fieldSpacing = { ps: Space.SPACE_4, paddingInlineEnd: Space.SPACE_8 };

export const nativeSelectSlotRecipe = defineSlotRecipe({
  slots: ['root', 'field', 'indicator'],
  base: {
    // Structural positioning: root anchors the indicator, which floats to the nearest
    // positioned ancestor without this.
    root: {
      display: 'flex',
      width: '100%',
      position: 'relative',
    },
    field: {
      ...inputFieldBase,
      appearance: 'none',
      paddingInlineStart: Space.SPACE_4,
      lineHeight: LineHeights.NORMAL,
      '--select-bg': `var(--udl-colors-${Colors.SURFACE_PAGE})`,
      bg: 'var(--select-bg)',
      '& > option, & > optgroup': {
        bg: 'var(--select-bg)',
      },
    },
    indicator: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      pointerEvents: 'none',
      width: Space.SPACE_6,
      height: '100%',
      insetEnd: Space.SPACE_2,
      _disabled: {
        color: Colors.TEXT_DISABLED,
      },
    },
  },
  variants: {
    variant: {
      outline: { field: inputFieldVariants.outline },
      filled: { field: inputFieldVariants.filled },
      flushed: { field: inputFieldVariants.flushed },
    },
    size: {
      lg: { field: { ...inputFieldSizes.lg, ...fieldSpacing } },
      md: { field: { ...inputFieldSizes.md, ...fieldSpacing } },
      sm: { field: { ...inputFieldSizes.sm, ...fieldSpacing } },
      xs: { field: { ...inputFieldSizes.xs, ...fieldSpacing }, indicator: { insetEnd: '1' } },
    },
  },
  defaultVariants: {
    size: 'md',
    variant: 'outline',
  },
});
